module.exports = __webpack_public_path__ + "static/Logo-Dourous-Net-63d303d740685a92cfd5e218811776e2.svg";